export const setParameter = (param, type, payload) => {
	return dispatch => {
		dispatch({
			type: type,
			payload: { [param]: payload },
		});
	};
};
